import React from "react"
import { useSelector } from "react-redux"
import Correct from "../../../images/svg/tick.svg"
import {
  selectUser,
  selectPaid
} from "../../../slices/authSlice"
import withLocation from "../../withLocation"
import FirebaseAuth from '../../../config/firebase'
import styles from "./membershipcard.module.scss"
import {loadStripe} from '@stripe/stripe-js';
import { navigate } from "gatsby"
import Button from '../../Common/Button/Button';

const axios = require('axios');

const MembershipCard = () => {
  const user = useSelector(selectUser)
  const paid = useSelector(selectPaid)

  async function checkout(){
    if(!user) {
      navigate('/login')
      return
    }
    let token = await FirebaseAuth.getCurrectUserToken()
    let stripe = await loadStripe(process.env.GATSBY_STRIPE_PUBLIC_KEY);

    let response = await axios.post(process.env.GATSBY_API_URL + '/create-session', {
        price_id: process.env.GATSBY_PRICE_ID,
        success_url: "http://beepbeep.uk/",
        cancel_url: "http://beepbeep.uk/",
        mode: "payment"
      }, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Access-Control-Allow-Origin': '*'
          },
      })
      stripe.redirectToCheckout({
        // Make the id field from the Checkout Session creation API response
        // available to this file, so you can provide it as argument here
        // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
        sessionId: response.data
      })
}

React.useEffect(() => {
  async function warmUp(){
    await axios.get(process.env.GATSBY_API_URL + '/healthcheck')
}
warmUp()
}, [])

  return (
    <div className={styles.card}>
      <div className={styles.header}>Most popular choice</div>
      <div className={styles.section1}>
        <div className={styles.left}>
          <h1>Personal Full*</h1>
          <h5>Dvsa learning material for all types of vehicles</h5>
        </div>
        <div className={styles.right}>
          <div className={styles.figure}>
            <div className={styles.symbol}>£</div>
            <h1>4.99</h1>
          </div>
          <div> 1-time payment</div>
        </div>
      </div>
      <hr />
      <div className={styles.section2}>
        <div className={styles.gridItem}>
          <div className={styles.svg}>
            <Correct />
          </div>
          Car Tests
        </div>
        <div className={styles.gridItem}>
        <div className={styles.svg}>
            <Correct />
          </div>
          Motorcycle Tests
        </div>
        <div className={styles.gridItem}>
        <div className={styles.svg}>
            <Correct />
          </div>
          LGV Tests
        </div>
        <div className={styles.gridItem}>
        <div className={styles.svg}>
            <Correct />
          </div>
          ADI Tests
        </div>
        <div className={styles.gridItem}>
        <div className={styles.svg}>
            <Correct />
          </div>
          Hazard Perception Tests
        </div>
        <div className={styles.gridItem}>
        <div className={styles.svg}>
            <Correct />
          </div>
          Ad-Free Experience
        </div>
      </div>
      <hr />
      <div>
        {paid ? (
          <div className={styles.purchased}>Purchased</div>
        ) : (
          <Button style={{marginTop: '2rem'}} onClick={checkout}>
            Get now
          </Button>
        )}
      </div>
    </div>
  )
}

export default withLocation(MembershipCard)
